import React, { useState } from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_openingtime-list.scss';
import { Button, Modal, Nav, Tab } from 'react-bootstrap';
import DateFnsUtils from "@date-io/date-fns";

import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import AddHoliday from './addholiday.component';

const OpenigTime = () => {

    const [modalCentered, setModalCentered] = useState(false);
    const handleClose = () => setModalCentered(false);

    const [selectedDate, handleDateChange] = useState(new Date());

    const [details, setDetails] = useState(false);

    const [mondayMultiInput, setMondayMultiInput] = useState([
        {
            startTime: '',
            endTime: ''
        },
    ]);

    const [tuesdayMultiInput, setTuesdayMultiInput] = useState([
        {
            startTime: '',
            endTime: ''
        },
    ]);

    const [wednesdayMultiInput, setWednesdayMultiInput] = useState([
        {
            startTime: '',
            endTime: ''
        },
    ]);

    const [thrusdayMultiInput, setThrusdayMultiInput] = useState([
        {
            startTime: '',
            endTime: ''
        },
    ]);


    const handleDetailsSidebar = (action) => {
        if (action === "open") {
            setDetails(true)
        }
        else {
            setDetails(false)
        }
    }


    // handle click event of the Add button
    const handleMondayAddClick = (e) => {
        e.preventDefault();
        setMondayMultiInput([
            ...mondayMultiInput,
            { startTime: '', endTime: '' },
        ]);
    };

    // handle click event of the Add button
    const handleTuesdayAddClick = (e) => {
        e.preventDefault();
        setTuesdayMultiInput([
            ...tuesdayMultiInput,
            { startTime: '', endTime: '' },
        ]);
    };


    // handle click event of the Add button
    const handleWednesdayAddClick = (e) => {
        e.preventDefault();
        setWednesdayMultiInput([
            ...wednesdayMultiInput,
            { startTime: '', endTime: '' },
        ]);
    };

    // handle click event of the Add button
    const handleThrusdayAddClick = (e) => {
        e.preventDefault();
        setThrusdayMultiInput([
            ...thrusdayMultiInput,
            { startTime: '', endTime: '' },
        ]);
    };

    return (
        <div className='openingTime'>
            <PageTitle title="Opening Times"
                subtitle="Opening Times" />

            <div className="row w-100 menu-top ml-0">
                <div className="col-md-10 col-lg-10">
                    <div className="d-flex align-items-center">
                        <i className='mdi mdi-information fs-5'> </i>
                        <small className='ml-2'> Please review your schedule and clicks 'Confirm Menu' when you are ready. You can edit and add your missing items. Restaurants usually take 1-2 working days to complete </small>
                    </div>
                </div>
                <div className="col-md-2 col-lg-2 justify-content-end text-right pr-0">
                    <button className='btn btn-sm btn-success rounded-0 py-1'>Confirm Menu</button>
                </div>
            </div>

            <div className="row mt-5">
                <Tab.Container id="left-tabs-example" defaultActiveKey="opening_hour">
                    <Nav variant="pills" className="d-flex">
                        <Nav.Item>
                            <Nav.Link eventKey="opening_hour">Opening Hours</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="holiday">Holidays and Specials Hours</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey="opening_hour">
                            <div className="row mt-3">
                                <div className="col-md-8 col-lg-8">
                                    <div className='card rounded-0'>
                                        <div className='card-body'>
                                            <h5>Opening Times</h5>
                                            <small>Selet when your kitchen is open for customers to place orders for delivery or self pick-up. Delivery rider hour may be different</small>
                                            <button onClick={() => setModalCentered(true)} className='btn btn-save rounded-0 d-block  py-1 mt-3'> Save Changes</button>
                                            <Modal className="fade" centered onHide={handleClose} show={modalCentered}>
                                                <Modal.Header className='flex-column justify-content-start'>
                                                    <Modal.Title>Apply to multiple outlets</Modal.Title>
                                                    <p>
                                                        Please select the outlets that you would like to apply these changes to
                                                    </p>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <input type="checkbox" />  <b> Oulet A</b>
                                                    <br />
                                                    <input type="checkbox" className='mt-3' />  <b> Oulet B</b>
                                                </Modal.Body>
                                                <Modal.Footer className='m-0 pl-0 pr-0'>
                                                    <div className="row w-100 align-items-center">
                                                        <div className="col-md-7 col-lg-7 d-flex">
                                                            <div className="d-flex">
                                                                <span style={{ color: '#5098d4' }}>NONE</span>
                                                                <span className='ml-3'>ALL</span>
                                                            </div>
                                                            <small className='ml-5'>1/2 Selected</small>
                                                        </div>
                                                        <div className="col-md-5 col-lg-5 d-flex justify-content-end align-items-center">
                                                            <span>CANCEL</span>
                                                            <button className='btn btn-sm btn-secondary rounded-0 py-1 ml-3'> SUBMIT</button>
                                                        </div>
                                                    </div>
                                                </Modal.Footer>

                                            </Modal>
                                        </div>
                                        <div className='card-header'>
                                            <div className="row w-100 border-2">
                                                <div className="col-md-6 col-lg-6 d-flex align-items-center">
                                                    <input type="checkbox" id='week' />
                                                    <label htmlFor="week" className='ml-1 mb-0'>Monday</label>
                                                </div>
                                                <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                                                    <div className="row w-100">
                                                        {
                                                            mondayMultiInput.map((data, index) =>
                                                                <div key={index} className="d-flex justify-content-end mt-4">
                                                                    <div className=''>
                                                                        <span>Start Time</span>
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                            <TimePicker
                                                                                autoOk
                                                                                label=""
                                                                                value={selectedDate}
                                                                                onChange={handleDateChange}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    </div>
                                                                    <div className='ms-5'>
                                                                        <span>End Time</span>
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                            <TimePicker
                                                                                autoOk
                                                                                label=""
                                                                                value={selectedDate}
                                                                                onChange={handleDateChange}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    </div>
                                                                </div>
                                                            )}

                                                        <div onClick={handleMondayAddClick} className="d-flex mt-4 hour" style={{ cursor: 'pointer' }}>
                                                            <small> <i className='mdi mdi-plus'> </i> Add Hours
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-body  rounded-0'>
                                            <div className="row border-2">
                                                <div className="col-md-6 col-lg-6 d-flex align-items-center">
                                                    <input type="checkbox" id='week' />
                                                    <label htmlFor="week" className='ml-1 mb-0'>Tuesday</label>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <div className="row w-100">
                                                        {
                                                            tuesdayMultiInput.map((data, index) =>
                                                                <div key={index} className="d-flex justify-content-end mt-4">
                                                                    <div className=''>
                                                                        <span>Start Time</span>
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                            <TimePicker
                                                                                autoOk
                                                                                label=""
                                                                                value={selectedDate}
                                                                                onChange={handleDateChange}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    </div>
                                                                    <div className='ms-5'>
                                                                        <span>End Time</span>
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                            <TimePicker
                                                                                autoOk
                                                                                label=""
                                                                                value={selectedDate}
                                                                                onChange={handleDateChange}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    </div>
                                                                </div>
                                                            )}

                                                        <div onClick={handleTuesdayAddClick} className="d-flex mt-4 hour" style={{ cursor: 'pointer' }}>
                                                            <small> <i className='mdi mdi-plus'> </i> Add Hours
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-body  rounded-0'>
                                            <div className="row  border-2">
                                                <div className="col-md-6 col-lg-6 d-flex align-items-center">
                                                    <input type="checkbox" id='week' />
                                                    <label htmlFor="week" className='ml-1 mb-0'>Wednesday</label>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <div className="row w-100">
                                                        {
                                                            wednesdayMultiInput.map((data, index) =>
                                                                <div key={index} className="d-flex justify-content-end mt-4">
                                                                    <div className=''>
                                                                        <span>Start Time</span>
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                            <TimePicker
                                                                                autoOk
                                                                                label=""
                                                                                value={selectedDate}
                                                                                onChange={handleDateChange}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    </div>
                                                                    <div className='ms-5'>
                                                                        <span>End Time</span>
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                            <TimePicker
                                                                                autoOk
                                                                                label=""
                                                                                value={selectedDate}
                                                                                onChange={handleDateChange}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    </div>
                                                                </div>
                                                            )}

                                                        <div onClick={handleWednesdayAddClick} className="d-flex mt-4 hour" style={{ cursor: 'pointer' }}>
                                                            <small> <i className='mdi mdi-plus'> </i> Add Hours
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-body  rounded-0'>
                                            <div className="row border-2">
                                                <div className="col-md-6 col-lg-6 d-flex align-items-center">
                                                    <input type="checkbox" id='week' />
                                                    <label htmlFor="week" className='ml-1 mb-0'>Thrusday</label>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <div className="row w-100">
                                                        {
                                                            thrusdayMultiInput.map((data, index) =>
                                                                <div key={index} className="d-flex justify-content-end mt-4">
                                                                    <div className=''>
                                                                        <span>Start Time</span>
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                            <TimePicker
                                                                                autoOk
                                                                                label=""
                                                                                value={selectedDate}
                                                                                onChange={handleDateChange}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    </div>
                                                                    <div className='ms-5'>
                                                                        <span>End Time</span>
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                            <TimePicker
                                                                                autoOk
                                                                                label=""
                                                                                value={selectedDate}
                                                                                onChange={handleDateChange}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    </div>
                                                                </div>
                                                            )}

                                                        <div onClick={handleThrusdayAddClick} className="d-flex mt-4 hour" style={{ cursor: 'pointer' }}>
                                                            <small> <i className='mdi mdi-plus'> </i> Add Hours
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="holiday">
                            <div className="card-header rounded-0 holiday-top-portion mt-3 pr-0">
                                <div className="row w-100 justify-content-between ">
                                    <div className="col-md-6 col-lg-6">
                                        <b className='fs-5'>Holiday and Special Hours</b>
                                    </div>
                                    <div className="col-md-6 col-lg-6 d-flex justify-content-end holiday-left">
                                        <span onClick={() => handleDetailsSidebar("open")} className='fs-5 fw-bold'>  <i className='mdi mdi-plus'> </i> Add Holiday and Special Hours</span>
                                    </div>
                                </div>
                            </div>
                            <div className="card rounded-0 holiday-card">
                                <div className="card-body">
                                    <small>please indicate when your restaurant will be closed or have different hours than usual.</small>
                                    <div className="message d-flex justify-content-center mt-5">
                                        <small> <b> You haven't added any holidays or special hours yet.</b> </small>
                                    </div>

                                </div>
                            </div>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
                <AddHoliday handleDetailsSidebar={handleDetailsSidebar} details={details} />

            </div>



        </div>
    );
};

export default OpenigTime;